<div class="chip" *ngIf="expiration;else alternativeTextTemplate">
  <label *ngIf="!expired">{{suffix}}&nbsp;</label><label>{{expiration}}</label>
</div>
<ng-template #alternativeTextTemplate>
  <p class="chip-alt-text" *ngIf="alternativeText">{{alternativeText}}</p>
</ng-template>
